/* eslint-disable */
export default {
  init() {
    const tabs = document.querySelector(".tabs");
    if (tabs) {
      const tabsBtns = tabs.querySelectorAll(".tabs__btn");
      const tabsContents = tabs.querySelectorAll(".tabs__content");
      const tabsWrapper = document.querySelectorAll(".stages-wrapper");

      function displayCurrentTab(current) {
        tabsWrapper[current].classList.add("active");
        for (let i = 0; i < tabsContents.length; i++) {
          tabsContents[i].style.display = current === i ? "block" : "none";
          if (current === i) {
            setTimeout(() => {
              tabsContents[i].classList.add("active");
            }, 300);
          } else {
            setTimeout(() => {
              tabsContents[i].classList.remove("active");
            }, 300);
          }
        }
      }
      function removeActiveFromTab() {
        document.querySelectorAll(".tabs__btn").forEach((item) => {
          item.classList.remove("active");
        });

        document.querySelectorAll(".stages-wrapper").forEach((item) => {
          item.classList.remove("active");
        });

        document.querySelectorAll(".main-stage-wrapper").forEach((item) => {
          item.classList.remove("active");
        });
      }
      displayCurrentTab(0);

      tabs.addEventListener("click", (event) => {
        if (event.target.classList.contains("tabs__btn")) {
          removeActiveFromTab();
          for (let i = 0; i < tabsBtns.length; i++) {
            if (event.target === tabsBtns[i]) {
              event.target.classList.add("active");
              displayCurrentTab(i);
              break;
            } else {
              removeActiveFromTab();
            }
          }
        }
      });
    } else {
      console.error("Element not found!");
    }
    // Get all the buttons for the first level of tabs
    const categoryButtons = document.querySelectorAll(
      ".buttons-container button"
    );

    let selectedContent = null;

    // Get all the stages (containers for the second level of tabs)
    const stages = document.querySelectorAll(".stages");

    // Get all the second level tabs (day-nav links)
    const dayNavs = document.querySelectorAll(".day-nav");

    const changeButtonState = (button) => {
      categoryButtons.forEach((btn) => btn.classList.remove("active"));

      // Add 'active' class to the clicked category button
      button.classList.add("active");

      // Get the data-cat attribute value of the clicked button
      const categoryId = button.getAttribute("data-cat");

      // Hide all stages
      stages.forEach((stage) => (stage.style.display = "none"));

      // Show the stage corresponding to the clicked category
      const selectedStage = document.getElementById(`stage-${categoryId}`);
      selectedContent = selectedStage;
      if (selectedStage) {
        selectedStage.style.display = "flex";
        selectedStage.querySelectorAll(".agenda-items")[0].style.display =
          "flex";
      }
    };

    const buttonHandler = (button) => {
      button.addEventListener("click", () => {
        changeButtonState(button);
      });
    };

    if (categoryButtons && categoryButtons.length) {
      changeButtonState(categoryButtons[0]);
    }

    // Add click event listeners to the category buttons
    categoryButtons.forEach((button) => {
      buttonHandler(button);
    });

    const daysHandler = (dayNav) => {
      dayNavs.forEach((nav) => nav.classList.remove("selected"));
      // Add 'selected' class to the clicked day-nav link
      dayNav.classList.add("selected");

      // Get the data-time attribute value of the clicked day-nav link
      const timeId = dayNav.getAttribute("data-time");

      // Hide all agenda items
      const agendaItems = document.querySelectorAll(".agenda-items");
      agendaItems.forEach((item) => (item.style.display = "none"));

      // Show the agenda items corresponding to the clicked time
      const selectedItems = selectedContent.querySelector(`#day-${timeId}`);
      if (selectedItems) {
        selectedItems.style.display = "flex";
      }
    };
    if (dayNavs && dayNavs.length) {
      daysHandler(dayNavs[0]);
    }

    // Add click event listeners to the second level tabs
    dayNavs.forEach((dayNav) => {
      dayNav.addEventListener("click", () => {
        daysHandler(dayNav);
      });
    });
  },

  finalize() {
    // JavaScript to be fired on the agenda page, after the init JS
  },
};
